import { IObstetricaLabResultsGroup } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { FormSideWidgetContainer, FormWidgetPosition } from "@/Patient/Components/MedicalNote/Forms/FormSideWidgetContainer";
import { ObstetricalFileLabObservationsContainer } from "../../../../../Common/Subcomponent/ObstetricalFileLabObservationsContainer";

class BritishColumbiaObstetricalFileLabWidgetProps {
    public obstetricalFileLabObservations: IObstetricaLabResultsGroup[];
    public finalEDB: Date;
}

class BritishColumbiaObstetricalFileLabWidget extends BaseReactComponent<BritishColumbiaObstetricalFileLabWidgetProps> {
    public render(): JSX.Element {
        return (
            <FormSideWidgetContainer
                width="200px"
                position={FormWidgetPosition.Left}
                topOffset="30"
                containerClassName="min-height-lab-widget"
            >
                <ObstetricalFileLabObservationsContainer
                    id="BritishColumbiaLabObservations"
                    observationGroups={this.props.obstetricalFileLabObservations}
                    finalEDB={this.props.finalEDB}
                    import={null}
                />
            </FormSideWidgetContainer>
        );
    }
}

export { BritishColumbiaObstetricalFileLabWidget };
